import api from "../../api";
import { useParams } from "react-router-dom";
import React, { useEffect, useCallback, useState, useRef } from "react";

import TableN2IGV from "./TableN2";
import TableN4IGV from "./TableN4";
import TableN5IGV from "./TableN5";
import TableN7IGV from "./TableN7";
import Loading from "../../components/Loading";
import IGVBrowser from "../../components/igv/IGVBrowser";

export default function IGVPage() {
    const params = useParams();

    const [type, setType] = useState("IGV");
    const [loading, setLoading] = useState(false);
    const [searchValue, setSearchValue] = useState("");

    const [position, setPosition] = useState(0);
    const [chromosome, setChromosome] = useState(0);

    const [N2, setN2] = useState([]);
    const [N4, setN4] = useState([]);
    const [N5, setN5] = useState([]);
    const [N7, setN7] = useState([]);

    const fetchIGV = useCallback(() => {
        setLoading(true);
        api.get(`/search/igv?search=${params?.name}`)
            .then((response) => {
                const data = response.data;
                setN2(data?.data?.n2 || []);
                setN4(data?.data?.n4 || []);
                setN5(data?.data?.n5 || []);
                setN7(data?.data?.n7 || []);
                setType(data.search_type);
                setSearchValue(data.search_value);
                setLoading(false);
                setPosition(data?.position ?? 0);
                setChromosome(data?.chromosome_no ?? 0);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [params?.name]);

    useEffect(() => {
        if (params?.name) {
            fetchIGV();
        }
    }, [params, fetchIGV]);

    if (loading) return <Loading />;

    return (
        <div className="container">
            {/* <div className="my-5"></div> */}
            <div className="h5 mb-4">
                {type ? type.charAt(0).toUpperCase() + type.substring(1) : "IGV"} : {searchValue}
            </div>

            {N2.length > 0 && (
                <div className="mb-4">
                    <TableN2IGV data={N2} />
                </div>
            )}

            {N4.length > 0 && (
                <div className="mb-4">
                    <TableN4IGV data={N4} />
                </div>
            )}

            {N5.length > 0 && (
                <div className="mb-4">
                    <TableN5IGV data={N5} />
                </div>
            )}

            {N7.length > 0 && (
                <div className="mb-4">
                    <TableN7IGV data={N7} />
                </div>
            )}

            {N2.length === 0 && N4.length === 0 && N5.length === 0 && N7.length === 0 && (
                <div className="mt-5 h5 text-center">
                    <span style={{ border: "1px solid #000000", padding: "10px 50px 10px 50px" }}>ไม่พบข้อมูลที่Search</span>
                </div>
            )}

            {Boolean(position && chromosome) && <IGVBrowser position={position} chromosome={chromosome} />}

            <br />
            <br />
            <br />
        </div>
    );
}
